import * as types from "../actionTypes";

export const setTechProductDevByYear = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_TECH_PRODUCT_DEV_BY_YEAR,
      key,
      yearKey,
      amount,
    });
  };
};

export const setTechProductDevByMonth = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_TECH_PRODUCT_DEV_BY_MONTH,
      key,
      yearKey,
      amount,
    });
  };
};

export const replaceTechProductDevYears = (key, payload) => {
  return (dispatch) => {
    return dispatch({
      type: types.REPLACE_TECH_PRODUCT_DEV_YEARS,
      key,
      payload,
    });
  };
};

export const resetTechProductDevReducer = () => {
  return (dispatch) => {
    return dispatch({
      type: types.RESET_TECH_PRODUCT_DEV_REDUCER,
    });
  };
};
